import * as React from 'react';

function SvgPaypalColourSquare(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.236 25.21l.377-2.395-.84-.02H6.765L9.55 5.134a.227.227 0 01.226-.193h6.76c2.243 0 3.792.467 4.6 1.388.38.433.62.884.737 1.381.123.522.125 1.145.005 1.906l-.008.055v.487l.379.215c.319.17.573.363.767.585.325.37.534.84.623 1.397.091.572.061 1.254-.089 2.026-.173.887-.452 1.66-.83 2.293a4.72 4.72 0 01-1.315 1.442 5.337 5.337 0 01-1.771.799c-.653.17-1.397.255-2.214.255h-.526c-.376 0-.741.136-1.028.379a1.593 1.593 0 00-.536.957l-.04.215-.665 4.219-.03.155c-.009.049-.022.073-.043.09a.11.11 0 01-.069.025h-3.247z"
        fill="#253B80"
      />
      <mask
        id="PaypalColourSquare_svg__a"
        maskUnits="userSpaceOnUse"
        x={10}
        y={9}
        width={15}
        height={17}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.459 9.726h13.97v16.22H10.46V9.726z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#PaypalColourSquare_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.608 9.726c-.02.13-.044.261-.07.396-.89 4.577-3.94 6.158-7.835 6.158H12.72a.963.963 0 00-.952.816l-1.015 6.439-.288 1.825a.507.507 0 00.501.586h3.517c.417 0 .77-.302.836-.713l.035-.179.662-4.202.042-.23a.846.846 0 01.836-.715h.526c3.408 0 6.075-1.384 6.855-5.387.326-1.673.157-3.07-.705-4.051a3.37 3.37 0 00-.962-.743z"
          fill="#179BD7"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.675 9.354a6.956 6.956 0 00-.867-.192 11.026 11.026 0 00-1.748-.127h-5.297a.842.842 0 00-.836.714l-1.126 7.138-.033.209a.963.963 0 01.952-.816h1.983c3.895 0 6.944-1.582 7.835-6.157.027-.136.05-.268.07-.397a4.77 4.77 0 00-.933-.372z"
        fill="#222D65"
      />
      <mask
        id="PaypalColourSquare_svg__b"
        maskUnits="userSpaceOnUse"
        x={6}
        y={4}
        width={17}
        height={20}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 4.202h16.706v19.333H6V4.202z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#PaypalColourSquare_svg__b)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.928 9.75a.842.842 0 01.835-.715h5.297c.628 0 1.214.041 1.748.128a6.948 6.948 0 011.067.254c.264.087.508.19.733.31.265-1.692-.002-2.843-.916-3.886-1.008-1.148-2.828-1.64-5.156-1.64H9.777a.966.966 0 00-.955.817L6.007 22.863a.58.58 0 00.573.672h4.173l1.048-6.648 1.127-7.138z"
          fill="#253B80"
        />
      </g>
    </svg>
  );
}

export default SvgPaypalColourSquare;
